module.exports = "<uib-tabset active=\"active\">\n  <uib-tab index=\"0\" heading=\"Permanente\">\n    <c-table columns=\"$ctrl.camposEquipo\" dataset=\"$ctrl.equipo.permanente\"></c-table>\n  </uib-tab>\n  <uib-tab index=\"1\" heading=\"A requerimiento\">\n    <c-table columns=\"$ctrl.camposEquipo\" dataset=\"$ctrl.equipo.requerido\"></c-table>\n  </uib-tab>\n</uib-tabset>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/empresas/c-empresas/equipo-minimo/equipo-minimo.html
// module id = 741
// module chunks = 0